import { DEFAULT_FONT_SIZE_IN_PIXELS } from '../constants';

export const getRem = (fontSize) => `${parseFloat(fontSize, 10) / DEFAULT_FONT_SIZE_IN_PIXELS}rem`;
